// extracted by mini-css-extract-plugin
export default {"footerCancelButton":"N0_af","contentWrapper":"ihWQ9","offerContainer":"vuWak","offerLink":"vlZtv","offerModal":"YNBSX","noAlignment":"L4TSz"};